import { render } from "./ShowNewsListItem.vue?vue&type=template&id=d022ffbe"
import script from "./ShowNewsListItem.vue?vue&type=script&lang=js"
export * from "./ShowNewsListItem.vue?vue&type=script&lang=js"

import "./ShowNewsListItem.vue?vue&type=style&index=0&id=d022ffbe&lang=css"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__